module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-3-e783c07b34f13d9276bf4da5274a1753.svg";